import { getEnvironmentFromHost } from '@ori/environment';
import { createSpaEntryfileUrl, getEnvironmentClientAppFileUrlPostfix } from './createSpaEntryfileUrl';
const PERSONAL_MENU_BLOB_NAME = 'personal-menu';
const getClientAppScriptElement = (clientAppName, environment) => document.querySelector(`script[src$="${clientAppName}/index${getEnvironmentClientAppFileUrlPostfix(environment)}.js"`);

// TODO: remove this after online is released with its own personal menu loader
/** Returns personal menu src, returns undefined if the script exists already */
export const getPersonalMenuScriptSrc = () => {
  const environment = getEnvironmentFromHost(window.location.host);
  const existingScript = getClientAppScriptElement(PERSONAL_MENU_BLOB_NAME, environment);

  // Skip for development, user should include the script tag themselves if not already present
  // 1. Start personal-menu-app webpack dev server on different port that top-area-app
  // 2. Create script tag in index.html and ensure that it is placed after the online-top-area-root element with id
  // 3. Add src argument to script tag that points to entrypoint of personal-menu-app: `http://localhost:<port>/index.js`
  // 4. Add defer argument
  // 5. Now it should load
  if (process.env.NODE_ENV === 'development') {
    return undefined;
  }

  // Skip if it exists
  if (existingScript) {
    return undefined;
  }
  const topAreaScript = getClientAppScriptElement('online-top-area', environment);
  const clientAppFileBaseUrl = new URL(topAreaScript.src);
  return createSpaEntryfileUrl(PERSONAL_MENU_BLOB_NAME, environment, clientAppFileBaseUrl.origin);
};